exports.ProductMap = {
  3: {
    '2kWh': [{
      name: 'Get Set Kit (2kWh)',
      pid: '6757458116681',
      varId: '39946294984777',
      adaptBatCap: 2,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '4747',
      old_price: '4497',
      install_price: 342,
      imgSrc: '/img/mm100/preview/setkit-2kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-2kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.',
      affirm: 'Starting at $165/mo* with Affirm.'
    }, {
      name: 'Prepared Kit (2kWh)',
      pid: '6757458116681',
      varId: '39946295017545',
      adaptBatCap: 2,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '5146',
      old_price: '5035',
      install_price: 375,
      imgSrc: '/img/mm100/preview/prekit-2kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-2kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.',
      affirm: 'Starting at $175/mo* with Affirm.'
    }, {
      name: 'Independence Kit (2kWh)',
      pid: '6757458116681',
      varId: '39946295050313',
      adaptBatCap: 2,
      limit: 2,
      off_price: '5445',
      old_price: '5453',
      install_price: 403,
      imgSrc: '/img/mm100/preview/indkit-2kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-2kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.',
      affirm: 'Starting at $189/mo* with Affirm.'
    }],
    '4kWh': [{
      name: 'Get Set Kit (4kWh)',
      pid: '6757463720009',
      varId: '39946320314441',
      adaptBatCap: 2,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '6496',
      old_price: '6496',
      install_price: 483,
      imgSrc: '/img/mm100/preview/setkit-4kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Batteries', '1x Cable Pack'],
      detailImgList: ['power-4kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.',
      affirm: 'Starting at $226/mo* with Affirm.'
    }, {
      name: 'Prepared Kit (4kWh)',
      pid: '6757463720009',
      varId: '39946320347209',
      adaptBatCap: 2,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '6895',
      old_price: '7073',
      install_price: 517,
      imgSrc: '/img/mm100/preview/prekit-4kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Batteries', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '2x Battery Mounting Straps'],
      detailImgList: ['bundle-4kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.',
      affirm: 'Starting at $236/mo* with Affirm.'
    }, {
      name: 'Independence Kit (4kWh)',
      pid: '6757463720009',
      varId: '39946320379977',
      adaptBatCap: 2,
      limit: 1,
      off_price: '7194',
      old_price: '7491',
      install_price: 545,
      imgSrc: '/img/mm100/preview/indkit-4kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Batteries', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '2x Battery Mounting Straps'],
      detailImgList: ['bundle-4kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.',
      affirm: 'Starting at $250/mo* with Affirm.'
    }],
    '5kWh': [{
      name: 'Get Set Kit (5kWh)',
      pid: '6757464277065',
      varId: '39946322247753',
      adaptBatCap: 5,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '7999',
      old_price: '7999',
      install_price: 542,
      imgSrc: '/img/mm100/preview/setkit-5kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-5kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.',
      affirm: 'Starting at $243/mo* with Affirm.'
    }, {
      name: 'Prepared Kit (5kWh)',
      pid: '6757464277065',
      varId: '39946322280521',
      adaptBatCap: 5,
      limit: 2,
      consoleChoose: 'Y',
      off_price: '8399',
      old_price: '8399',
      install_price: 575,
      imgSrc: '/img/mm100/preview/prekit-5kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-5kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.',
      affirm: 'Starting at $253/mo* with Affirm.'
    }, {
      name: 'Independence Kit (5kWh)',
      pid: '6757464277065',
      varId: '39946322313289',
      adaptBatCap: 5,
      limit: 2,
      off_price: '8699',
      old_price: '8699',
      install_price: 603,
      imgSrc: '/img/mm100/preview/indkit-5kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-5kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.',
      affirm: 'Starting at $267/mo* with Affirm.'
    }],
    '10kWh': [{
      name: 'Get Set Kit (10kWh)',
      pid: '6757469388873',
      varId: '39946340499529',
      adaptBatCap: 5,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '12499',
      old_price: '12499',
      install_price: 833,
      imgSrc: '/img/mm100/preview/setkit-10kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Batteries', '1x Cable Pack'],
      detailImgList: ['power-10kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.',
      affirm: 'Starting at $382/mo* with Affirm.'
    }, {
      name: 'Prepared Kit (10kWh)',
      pid: '6757469388873',
      varId: '39946340532297',
      adaptBatCap: 5,
      limit: 1,
      consoleChoose: 'Y',
      off_price: '12899',
      old_price: '12899',
      install_price: 867,
      imgSrc: '/img/mm100/preview/prekit-10kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Batteries', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '2x Battery Mounting Straps'],
      detailImgList: ['bundle-10kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.',
      affirm: 'Starting at $392/mo* with Affirm.'
    }, {
      name: 'Independence Kit (10kWh)',
      pid: '6757469388873',
      varId: '39946340565065',
      adaptBatCap: 5,
      limit: 1,
      off_price: '13199',
      old_price: '13199',
      install_price: 895,
      imgSrc: '/img/mm100/preview/indkit-10kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Batteries', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '2x Battery Mounting Straps'],
      detailImgList: ['bundle-10kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.',
      affirm: 'Starting at $406/mo* with Affirm.'
    }],
    '15kWh': [{
      name: 'Get Set Kit (15kWh)',
      pid: '6757470011465',
      varId: '39946344562761',
      consoleChoose: 'Y',
      off_price: '16999',
      old_price: '16999',
      install_price: 1125,
      imgSrc: '/img/mm100/preview/setkit-15kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Batteries', '1x Cable Pack'],
      detailImgList: ['power-15kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.',
      affirm: 'Starting at $520/mo* with Affirm.'
    }, {
      name: 'Prepared Kit (15kWh)',
      pid: '6757470011465',
      varId: '39946344595529',
      consoleChoose: 'Y',
      off_price: '17399',
      old_price: '17399',
      install_price: 1158,
      imgSrc: '/img/mm100/preview/prekit-15kw.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Batteries', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '3x Battery Mounting Straps'],
      detailImgList: ['bundle-15kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.',
      affirm: 'Starting at $531/mo* with Affirm.'
    }, {
      name: 'Independence Kit (15kWh)',
      pid: '6757470011465',
      varId: '39946344628297',
      off_price: '17699',
      old_price: '17699',
      install_price: 1187,
      imgSrc: '/img/mm100/preview/indkit-15kw-us.jpg',
      delivery_date: 'Mid August 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Batteries', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '3x Battery Mounting Straps'],
      detailImgList: ['bundle-15kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.',
      affirm: 'Starting at $544/mo* with Affirm.'
    }]
  }
};
exports.solarPanelMap = {
  3: [{
    name: '2*100W Rigid Solar Panel+2*Rigid solar mounting feet',
    pid: '6761262973001',
    varId: '39962928152649',
    old_price: '219',
    off_price: '219',
    limit: 99,
    imgSrc: '/img/mm100/preview/rigid-100w.jpg'
  }, {
    name: '2*400W Rigid Solar Panel+4*Rigid solar mounting feet',
    pid: '6761270444105',
    varId: '39962923532361',
    old_price: '739',
    off_price: '739',
    limit: 99,
    tips: '*This item excludes free shipping.',
    imgSrc: '/img/mm100/preview/rigid-400w.jpg'
  }, {
    name: '1*100W Flexible Solar Panel',
    pid: '6761895231561',
    varId: '39962853343305',
    old_price: '199',
    off_price: '199',
    // save_money: '0',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-100w.jpg'
  }, {
    name: '1*400W Portable Solar Panel',
    pid: '6618094960713',
    varId: '39998021697609',
    old_price: '1199',
    off_price: '1199',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-400w.jpg'
  }]
};
exports.BatteryMap = {
  3: [{
    name: '2kWh LFP Battery',
    pid: '6761212510281',
    varId: '39958505095241',
    off_price: '1749',
    old_price: '1749',
    capacity: 2,
    imgSrc: '/img/mm100/preview/battery-2kw.jpg'
  }, {
    name: '5kWh LFP Battery',
    pid: '6761212510281',
    varId: '39958505128009',
    off_price: '4999',
    old_price: '4999',
    capacity: 5,
    imgSrc: '/img/mm100/preview/battery-5kw.jpg'
  }]
};
exports.InstallationMap = {
  3: {
    pid: '6776213012553',
    varId: '40019530055753',
    off_price: '0',
    old_price: '0',
    save_money: '0'
  }
};
exports.ConsoleMap = {
  3: [{
    name: 'EcoFlow Power Kits Console',
    pid: '6788705878089',
    varId: '40062543495241',
    off_price: '349',
    old_price: '349',
    limit: 1,
    imgSrc: '/img/calculators/mm100/combo-console.jpg'
  }]
};
exports.ShopifyUrl = 'https://us.ecoflow.com/';